'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSignalBars, iconSignalBarsTag } from '@ni/nimble-components/dist/esm/icons/signal-bars';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSignalBars };
export { iconSignalBarsTag };
export const NimbleIconSignalBars = wrap(IconSignalBars);